
import { findSignature } from "../services/signature";
import { isWeixinBrowser, queryStringParam, replaceStringParam } from "../utils/index";

export const weixinShare = (data,staus = false) => {
    var title = data.title;
    var des = data.des;
    var img = data.img;
    //自定义分享链接
    var _link = window.location.href;
    var userId = localStorage.getItem('attendeeUserId');
    if (userId && staus) {
        if (queryStringParam('levelOne')) {
            if (queryStringParam('levelTwo')) {
                _link = replaceStringParam('levelTwo', userId);
            } else {
                _link = window.location.href + '&levelTwo='+userId;
            }

        } else {
            if (window.location.href.indexOf('?') > -1) {
                _link = `${window.location.href}&levelOne=${userId}`;
            } else {
                _link =`${window.location.href}?levelOne=${userId}`;;
            }

        }
    }




    console.log(_link)
    //QQ分享
    window.setShareInfo({
        title: title, // 分享标题
        summary: des, // 分享内容
        pic: img, // 分享图片
        // url:            'http://qzs.qzone.qq.com/qzone/qzact/act/2015/father-day-m/index.html', // 分享链接
        // // 微信权限验证配置信息，若不在微信传播，可忽略
        // WXconfig: {
        //     swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
        //     appId: appId, // 公众号的唯一标识
        //     timestamp: timestamp, // 生成签名的时间戳
        //     nonceStr: nonceStr, // 生成签名的随机串
        //     signature: signature // 签名
        // }
    });
    if (isWeixinBrowser()) {
        findSignature({ url: encodeURI(window.location.href) }).then(res => {
            if (res.code === 200) {
                window.wx.config({
                    debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature,// 必填，签名，见附录1
                    jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });

                window.wx.ready(function () {
                    //分享给朋友
                    window.wx.onMenuShareAppMessage({
                        title: title, // 分享标题
                        desc: des, // 分享描述
                        link: _link, // 分享链接
                        imgUrl: img, // 分享图标
                        //type: '', // 分享类型,music、video或link，不填默认为link
                        //dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                    //分享到朋友圈
                    window.wx.onMenuShareTimeline({
                        title: title, // 分享标题
                        // desc: des, // 分享描述
                        link: _link, // 分享链接
                        imgUrl: img, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                    //分享到QQ
                    window.wx.onMenuShareQQ({
                        title: title, // 分享标题
                        desc: des, // 分享描述
                        link: _link, // 分享链接
                        imgUrl: img, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                    //分享到QQ空间
                    window.wx.onMenuShareQZone({
                        title: title, // 分享标题
                        desc: des, // 分享描述
                        link: _link, // 分享链接
                        imgUrl: img, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                });

            }
        }).catch(err => {
        }).finally(() => {
        })
    }


};




// WEBPACK FOOTER //
// ./src/utils/share.js